import { gql } from '@apollo/client';

export const GET_NOTES_FOR_CLIENT = gql`
  query GetNotesForClient($clientId: String!, $coachId: String!) {
    getNotes(clientId: $clientId, coachId: $coachId) {
      id
      type
      text
      createdAt
      updatedAt
    }
  }
`;

export const GET_NOTES_FOR_CLIENT_LAST_NOTE = gql`
  query GetNotesForClient(
    $clientId: String!
    $coachId: String!
    $page: Int!
    $pageSize: Int!
    $orderBy: String!
    $order: String!
  ) {
    getNotes(
      clientId: $clientId
      coachId: $coachId
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      order: $order
    ) {
      id
      text
      counter
      html
      createdAt
      updatedAt
      archived
    }
  }
`;

export const ADD_TEXT_NOTE_FOR_CLIENT = gql`
  mutation AddNotesForClient($clientId: String!, $coachId: String!, $text: String!, $html: String) {
    addNote(addNoteInput: { clientId: $clientId, coachId: $coachId, html: $html, text: $text }) {
      id
      clientId
      coachId
      html
      text
      archived
      createdAt
      updatedAt
    }
  }
`;

export const GET_PRE_SIGNED_URL = gql`
  query GetPreSignedUrl($clientId: String!, $fileName: String!, $contentType: String!) {
    getNotePicutureUploadURL(
      CreatePreSignedUrl: { clientId: $clientId, contentType: $contentType, fileName: $fileName }
    ) {
      url
      fileName
      contentType
      key
    }
  }
`;

export const EDIT_TEXT_NOTE_BLOCK = gql`
  mutation EditTextNoteBlock(
    $clientId: String!
    $coachId: String!
    $noteId: String!
    $text: String!
    $isForceSuggestions: Boolean!
    $html: String
  ) {
    editNote(
      editNoteInput: {
        clientId: $clientId
        coachId: $coachId
        text: $text
        id: $noteId
        isForceSuggestions: $isForceSuggestions
        html: $html
      }
    ) {
      id
      clientId
      coachId
      html
      text
      archived
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_MEDIA_NOTE_BLOCK = gql`
  mutation EditMediaNoteBlock(
    $noteId: String!
    $clientId: String!
    $coachId: String!
    $type: NoteType!
    $fileName: String!
    $contextType: String!
  ) {
    editNote(
      editNoteInput: {
        id: $noteId
        clientId: $clientId
        coachId: $coachId
        type: $type
        fileName: $fileName
        contentType: $contextType
      }
    ) {
      id
      clientId
      coachId
      type
      text
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_TEXT_NOTE_FOR_CLIENT = gql`
  mutation DeleteNotesForClient($id: String!) {
    deleteNote(id: $id) {
      id
      clientId
      coachId
      html
      text
      archived
      createdAt
      updatedAt
    }
  }
`;

export const SAVE_NOTE_RECORDING = gql`
  mutation SaveNoteRecording(
    $clientId: String!
    $coachId: String!
    $noteId: String!
    $recording: String!
    $transcription: String!
    $contentType: String!
    $suggestions: [SuggestionDto!]!
  ) {
    saveNoteRecording(
      saveNoteRecordingInput: {
        clientId: $clientId
        coachId: $coachId
        noteId: $noteId
        recording: $recording
        transcription: $transcription
        contentType: $contentType
        suggestions: $suggestions
      }
    ) {
      id
      transcription
      presignedUrl
      recording
    }
  }
`;

export const GET_NOTE_RECORDINGS_FOR_CLIENT = gql`
  query GetNoteRecordings($clientId: String!, $coachId: String!, $noteId: String!) {
    getNoteRecordings(clientId: $clientId, coachId: $coachId, noteId: $noteId) {
      id
      transcription
      presignedUrl
      recording
      noteId
    }
  }
`;

export const DELETE_RECORDING_FOR_CLIENT = gql`
  mutation DeleteNoteRecording($clientId: String!, $coachId: String!, $recordingId: String!) {
    deleteNoteRecording(clientId: $clientId, coachId: $coachId, recordingId: $recordingId) {
      id
    }
  }
`;

export const GET_NOTE_SUGGESTIONS = gql`
  query GetNoteSuggestions($getNoteSuggestionsInput: GetNoteSuggestionsInput!) {
    getNoteSuggestions(getNoteSuggestionsInput: $getNoteSuggestionsInput) {
      id
      clientId
      coachId
      noteId
      suggestion
      type
    }
  }
`;

export const DELETE_NOTE_SUGGESTIONS = gql`
  mutation removeNoteSuggestions($suggestionIds: [String!]!) {
    removeNoteSuggestions(suggestionIds: $suggestionIds) {
      success
    }
  }
`;
